// import axios from './mock/mock'
import axios from 'axios'
import Qs from 'qs'
import { getToken, removeToken } from '@/utils/auth'
import Vue from 'vue'
// import { Loading } from 'element-ui'

Vue.prototype.axios = axios

let needLoadingRequestCount = 0
// let loading

const service = axios.create({
  timeout: 60000,
  transformRequest: [
    function(data) {
      if (!data) {
        data = {}
      }
      const jsonText = { ...data }
      delete jsonText.token
      const postData = {}
      postData.jsonText = jsonText ? JSON.stringify(jsonText) : ''
      postData.token = data.token || getToken()
      postData.device_type = '50'
      postData.system = '2'
      return Qs.stringify(postData)
    }
  ]
})

service.interceptors.request.use(
  config => {
    showFullScreenLoading()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()
    if (response.status !== 200) {
      Vue.prototype.$toast.fail('数据异常，请联系管理员')
      return
    }
    const status = response.data.status
    if (status.succeed === '1') {
      return response
    }
    treatErrorCode(response)
    return Promise.reject(new Error(+response.data.status.error_code === 401 ? '' : status.error_desc))
  },
  (err) => {
    tryHideFullScreenLoading()
    console.log(err)
    // Sentry.captureException(err, {
    //   level: 'error'
    // })
    return Promise.reject(err)
  }
)

const treatErrorCode = res => {
  if (+res.data.status.error_code === 401) {
    // Vue.prototype.$toast.fail('登陆失效请重新登陆')
    // setTokenByKey('', 'Admin-Token-v1')
    removeToken()
    window.location.reload()
    // window.location.href = res.data.redirect_url
  } else {
    // Sentry.captureException({
    //   ...res,
    //   data: {
    //     ...res.data,
    //     data: JSON.stringify(res.data.data),
    //     status: JSON.stringify(res.data.status)
    //   }
    // }, {
    //   level: 'error'
    // })
  }
}

const showFullScreenLoading = () => {
  if (needLoadingRequestCount === 0) {
    // startLoading()
  }
  needLoadingRequestCount++
}

const tryHideFullScreenLoading = () => {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    // endLoading()
  }
}

// const startLoading = () => {
//   loading = Loading.service({
//     lock: true,
//     text: '加载中...',
//     fullscreen: false,
//     spinner: 'el-icon-loading',
//     background: 'rgba(255, 255, 255, 0.7)'
//   })
// }

// const endLoading = () => {
//   loading.close()
// }

export default service
